/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import TrustCommercebillingsBilling from './TrustCommercebillingsBilling';

/**
 * The TrustCommerceBillingsBody model module.
 * @module model/TrustCommerceBillingsBody
 * @version v0.3
 */
export default class TrustCommerceBillingsBody {
  /**
   * Constructs a new <code>TrustCommerceBillingsBody</code>.
   * @alias module:model/TrustCommerceBillingsBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>TrustCommerceBillingsBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrustCommerceBillingsBody} obj Optional instance to populate.
   * @return {module:model/TrustCommerceBillingsBody} The populated <code>TrustCommerceBillingsBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TrustCommerceBillingsBody();
      if (data.hasOwnProperty('billing'))
        obj.billing = TrustCommercebillingsBilling.constructFromObject(data['billing']);
    }
    return obj;
  }
}

/**
 * @member {module:model/TrustCommercebillingsBilling} billing
 */
TrustCommerceBillingsBody.prototype.billing = undefined;

